module.exports = __webpack_public_path__ + "static/img/wxcode.64831ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wxcode.png
// module id = qy7J
// module chunks = 1